export enum Category {
  Supplier = 'Supplier',
  Shipowner = 'Shipowner',
  Charterer = 'Charterer',
  LBVOperator = 'LBV Operator',
}
